import styled from "@emotion/styled";
import { CloseIcon, Cloud } from "components/Icons";
import { useState } from "react";
import { GlobalStore } from "store/global/GlobalStore";

interface NoticeProps {
  title: string;
  body: string;
  link?: string;
}

export const Notice = ({ title, body, link }: NoticeProps) => {
  const [isOpen, setIsOpen] = useState(true);
  const theme = GlobalStore.useState(s => s.theme);

  if (!isOpen) {
    return null;
  }

  return (
    <Container>
      <Header>
        <HeaderContent>
          <Cloud
            width={28}
            height={28}
            fill={theme["Brand colours"].Aqua}
            color={theme["Brand colours"].Aqua}
          />
          <Title>{title}</Title>
        </HeaderContent>
        <CloseContainer>
          <CloseIcon
            onClick={() => setIsOpen(false)}
            color={theme["Dark mode"][900]}
            width={20}
            height={20}
          />
        </CloseContainer>
      </Header>
      <Body>
        {body}{" "}
        <Link href={link} target="_blank" rel="noreferrer">
          Read more.
        </Link>
      </Body>
    </Container>
  );
};

// Sub-components

const Container = styled.div`
  position: relative;
  width: 158px;
  padding: 10px 9px 14px 9px;
  background-color: ${props => props.theme.surface.main.primary.default};
  border-radius: 14px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
`;

const HeaderContent = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  height: 100%;
`;

const CloseContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Title = styled.h4`
  font-size: ${props => props.theme.fontSize[5]};
  font-weight: ${props => props.theme.fontWeights["work-sans-0"]};
  line-height: 16px;
  margin-bottom: 0;
`;

const Body = styled.p`
  font-size: 10px;
  font-family: Work Sans;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  margin: 0;
`;

const Link = styled.a`
  transition: color 0.2s;
  &:hover {
    color: ${props => props.theme["Brand colours"].Aqua};
  }
`;
